import { useEffect, useState } from "react";
import { BellRing, X } from "lucide-react";
import { Link } from "react-router-dom";
import { pushSupport, permission, currentSubscription, NUDGE_KEY } from "../lib/push";

/* One-time, dismissible nudge on the dashboard: shown only when alerts aren't enabled on this device. */
export const AlertsNudge = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (localStorage.getItem(NUDGE_KEY) || !pushSupport().ok || permission() === "denied") return;
    currentSubscription().then((s) => setShow(!s)).catch(() => null);
  }, []);
  if (!show) return null;
  const dismiss = () => { localStorage.setItem(NUDGE_KEY, "1"); setShow(false); };
  return (
    <div className="card mb-4 flex items-start gap-3 fade-up" data-testid="alerts-nudge">
      <BellRing size={18} className="text-primary shrink-0 mt-0.5" />
      <div className="flex-1">
        <p className="text-sm font-semibold">Get alerted when someone claims or completes a job</p>
        <Link to="/app/settings#notifications" className="text-sm text-primary underline" onClick={dismiss} data-testid="alerts-nudge-link">Enable notifications</Link>
      </div>
      <button type="button" className="icon-btn" onClick={dismiss} aria-label="Dismiss" data-testid="alerts-nudge-dismiss"><X size={14} /></button>
    </div>
  );
};
